import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-c-dark">
      {/* Header */}
      <div className="bg-c-dark pt-20 pb-16">
        <div className="max-w-[800px] mx-auto px-6 md:px-12">
          <a href="/" className="font-wordmark text-c-cream text-lg hover:text-white transition-colors inline-block mb-16">
            chRsMa
          </a>
          <h1 className="text-4xl md:text-5xl font-light text-white mb-4">
            Privacy <span className="font-serif-italic text-gradient">Policy</span>
          </h1>
          <p className="text-sm text-c-powder/50">Last updated: April 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-c-cream py-20 md:py-32">
        <div className="max-w-[800px] mx-auto px-6 md:px-12">
          <div className="prose-chrsma">
            <h2>Information We Collect</h2>
            <p>
              When you submit an inquiry through our contact form, we collect your name, company name, email address, and the content of your message. This information is used solely to respond to your inquiry and evaluate potential partnerships.
            </p>

            <h2>How We Use Your Information</h2>
            <p>
              We use the information you provide to respond to inquiries, evaluate partnership fit, and communicate about our services. We do not sell, trade, or share your personal information with third parties for marketing purposes.
            </p>

            <h2>Cookies & Analytics</h2>
            <p>
              This site may use minimal analytics to understand traffic patterns. We do not use advertising cookies or tracking pixels. Any analytics data collected is aggregated and anonymized.
            </p>

            <h2>Data Retention</h2>
            <p>
              We retain inquiry data for the duration of any active business relationship and for a reasonable period afterward. You may request deletion of your data at any time by contacting hello@chrsma.co.
            </p>

            <h2>Third-Party Services</h2>
            <p>
              This site uses Google Fonts for typography delivery. Google's privacy policy governs the use of their font service. We do not embed third-party tracking scripts or advertising frameworks.
            </p>

            <h2>Your Rights</h2>
            <p>
              You have the right to access, correct, or delete any personal information we hold about you. To exercise these rights, contact us at hello@chrsma.co.
            </p>

            <h2>Contact</h2>
            <p>
              For questions about this privacy policy, contact us at <a href="mailto:hello@chrsma.co">hello@chrsma.co</a>.
            </p>
          </div>
        </div>
      </div>

      {/* Footer link */}
      <div className="bg-c-dark py-12">
        <div className="max-w-[800px] mx-auto px-6 md:px-12 flex justify-between items-center">
          <a href="/" className="text-xs text-c-powder/50 hover:text-c-cream transition-colors tracking-widest uppercase">&larr; Back to Home</a>
          <a href="/terms" className="text-xs text-c-powder/50 hover:text-c-cream transition-colors tracking-widest uppercase">Terms of Service</a>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
